// extracted by mini-css-extract-plugin
export default {"headerText":"HeaderText_headerText__y29WK"};